import Emojis from '@/common/components/ui/Emoji/emojis';
import {Emoji} from '@/common/components/ui/Emoji/emojis';

export default {
  toEmoji(text: string): string {
    const regex = /\[[^\]]*\]/g;
    const emojis = text.match(regex);
    if (emojis !== null) {
      emojis.forEach((val) => {
        const tmp = val.substring(1, val.length - 1);
        const emoji = Emojis.find((emoji: Emoji) => emoji.name === tmp);
        if (emoji) {
          text = text.replace(val, emoji.char);
        }
      });
    }
    return text;
  },
  toText(text: string): string {
    Emojis.forEach((emoji: Emoji) => {
      text = text.replace(new RegExp(emoji.char, 'g'), '[' + emoji.name + ']');
    });
    return text;
  },
};
